type AuthorizationConfig = {
    currentRegion: string;
    currentUserState: string;
    isKidProfile: boolean;
};

export default class Authorization {
    private regionsToInclude: string[];
    private regionsToExclude: string[];
    private allRegions = false;
    private authorizedUserStates: string[];
    private allowKidsProfiles = false;

    constructor(
        regionsToInclude: string[] = ['us'],
        userStatesToInclude: string[] = ['SUBSCRIBER'],
    ) {
        this.allRegions = false;
        this.regionsToInclude = regionsToInclude;
        this.regionsToExclude = [];
        this.authorizedUserStates = userStatesToInclude;
    }

    coreTestAllowed({
        currentRegion,
        currentUserState,
        isKidProfile,
    }: AuthorizationConfig): boolean {
        if (this.inRegionToExclude(currentRegion)) {
            return false;
        }

        if (!this.isRegionAllowed(currentRegion)) {
            return false;
        }

        if (!this.isUserAuthorized(currentUserState, isKidProfile)) {
            return false;
        }

        return true;
    }

    inRegionToExclude(currentRegion: string): boolean {
        return this.regionsToExclude.includes(currentRegion);
    }

    isRegionAllowed(currentRegion: string): boolean {
        if (this.allRegions) {
            return true;
        } else if (this.regionsToInclude.includes(currentRegion)) {
            return true;
        }
        return false;
    }

    isUserAuthorized(currentUserState: string, isKidProfile = false) {
        if (isKidProfile && !this.allowKidsProfiles) {
            return false;
        }
        return this.authorizedUserStates && this.authorizedUserStates.includes(currentUserState);
    }

    setRegionsToInclude(regionsToInclude: string[]): Authorization {
        this.regionsToInclude = regionsToInclude;
        return this;
    }

    setAuthorizedUserStates(allowUserStates: string[]): Authorization {
        this.authorizedUserStates = allowUserStates;
        return this;
    }

    testAllowed(): boolean {
        return true;
    }

    setRegionToExclude(regionToExclude: string[]): Authorization {
        this.regionsToExclude = regionToExclude;
        return this;
    }

    setAllRegions(allowAll: boolean): Authorization {
        this.allRegions = allowAll;
        return this;
    }
}
